var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('devices-table',{attrs:{"devicesList":_vm.devicesList,"showAllDeviceDetails":false,"itemsPerPage":_vm.devicesList.data?.length,"clickable":true},on:{"click-row":function($event){return _vm.handleRowClick($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }